var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWaitingRoom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#ED9082",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06994 3.62206L9.72865 3.32565C9.84392 3.26801 9.90979 3.43269 9.80275 3.49032L9.02877 3.86084C8.9629 3.90201 8.8888 3.84438 8.8888 3.77851V2.84808C8.8888 2.73281 9.06994 2.72458 9.06994 2.84808V3.62206Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03701 2C8.11482 2 7.36554 2.74928 7.36554 3.67147C7.36554 4.59366 8.11482 5.34293 9.03701 5.34293C9.95919 5.34293 10.7085 4.59366 10.7085 3.67147C10.7085 2.75751 9.95919 2 9.03701 2ZM9.03701 5.03005C8.28773 5.03005 7.67842 4.42075 7.67842 3.67147C7.67842 2.92219 8.28773 2.31289 9.03701 2.31289C9.78628 2.31289 10.3956 2.92219 10.3956 3.67147C10.3874 4.42075 9.77805 5.03005 9.03701 5.03005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76365 4.1902C5.33662 4.1902 5.80111 3.72571 5.80111 3.15274C5.80111 2.57976 5.33662 2.11527 4.76365 2.11527C4.19067 2.11527 3.72619 2.57976 3.72619 3.15274C3.72619 3.72571 4.19067 4.1902 4.76365 4.1902Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00778 7.45903H6.26221L5.79288 5.12062C5.51293 3.90201 3.80029 4.2643 3.98144 5.45821L4.52487 8.17537C4.60721 8.58706 4.93656 8.94112 5.45529 8.94112H7.68666V11.4113C7.68666 12.1935 8.78176 12.1935 8.78176 11.4277V8.24124C8.78176 7.86248 8.51827 7.45903 8.00778 7.45903Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39765 9.13873H6.86327C7.43964 9.13873 7.43964 9.99505 6.87974 9.99505H5.27415C4.49193 9.99505 3.71795 9.41044 3.51211 8.50472L3.00984 6.08398C2.9028 5.53231 3.70149 5.34293 3.81676 5.91107L4.29432 8.23301C4.42606 8.82584 4.87069 9.13873 5.39765 9.13873Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaitingRoom);
export default __webpack_public_path__ + "static/media/icon-waiting-room.dd75d92bd7f71584b32e3b073a7b2ac3.svg";
export { ForwardRef as ReactComponent };